import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spotlightHeaderNonFinal: {
		id: 'servicedesk-better-in-product-guidance.spotlight.spotlight-header-non-final',
		defaultMessage: 'Reopen the product guide panel',
		description: 'Spotlight header when better in product guidance panel is dismissed',
	},
	spotlightContentNonFinal: {
		id: 'servicedesk-better-in-product-guidance.spotlight.spotlight-content-non-final',
		defaultMessage:
			'Select <bold>Help</bold> <icon></icon> then <bold>Launch product guide</bold> to browse or search for help articles about request types.',
		description: 'Spotlight content when better in product guidance panel is dismissed',
	},
});
